import { supabase } from './supabase'

export const productImageUrl = (path?: string | null) => {
  if (!path) return ''
  return supabase.storage.from('product-images').getPublicUrl(path).data.publicUrl
}
